import classNames from 'classnames';
import {
  useHideGetItBy,
  useHideShipping
} from 'search/src/components/SearchResults/ResultTile/hooks';

type OwnProps = {
  getItBy: string;
};

const BottomFrameRule = ({ getItBy }: OwnProps) => {
  const hideShipping = useHideShipping();
  const hideGetItBy = useHideGetItBy(getItBy);
  const hideLine = hideShipping && hideGetItBy;

  return <hr className={classNames('hr-tilekit', { invisible: hideLine })} />;
};

export default BottomFrameRule;
